export class PageRequest{
  _page = 1;
  _limit = 10;
  _sort: string | undefined;
  constructor(limit = 10) {
    this._limit = limit;
  }
}
